import styled from 'styled-components';


export const Titlebody = styled.div`
  position:relative;
  top:-4px;
       background:#e6eef4;
`

export const Menubar = styled.div `
  width:100%;
  display:flex;
  justify-content:flex-start;
    background: #f5f5f7;

  /* z-index:10; */

`

export const Unit = styled.div`


  box-shadow: 0 4px 8px rgba(0,0,0,0.25), 0 7px 7px rgba(0,0,0,0.22);
  text-align:center;

  min-height: 48px;
  height: ${props => (props.bool ? '97vh' : props.winheight/98+'px')};

  width: ${props => (props.bool ? '99%' : '29vw')};
  // padding-top: 1em;
  padding-top: ${props=>props.winheight/380+5}px;
  background: #efeffa;
  transition: all 300ms ease-in-out;
  margin: 2px;

`;

export const Unitsblock = styled.div `

  background: #f5f5f7;
  position:relative;
  top:-11px;
  height: 80vh;
  display: flex;
  justify-content: space-around;
  align-content: space-around;
  ${props=>(props.extrasmall ?  'flex-direction:column;' :'flex-wrap: wrap;') }
  color:#273049;
  font-size:1.2em;
`;

export const Unitfull = styled.div`
  text-align:center;
  position: absolute;
  top:${props=>props.winheight/90}px;
  left:1px;
  height: ${props => props.winheight+'px'};
  width: 99%;
  padding-top: 1em;
  background: white;
  transition: all 80ms ease-in-out;
  z-index: ${props => (props.bool ? '5' : null)};
`;


export const Appmain =styled.div`
  margin: 0px;
  height: 100vh;
  width:100%;
  text-align: center;
   overflow-y:visible;
   background: #b3c0c7;
`




export const Contentheader=styled.div`

    color:#1a1a46;
    font-weight: bold;
    font-family: cursive;
    width: 99%;
    /* text-align: right; */
    justify-content:space-between;
    padding-right: 15px;
    /* cursor: pointer; */
    z-index: 11;
    position: relative;
    top:-25;
    display: flex;

`;

export const Message = styled.div`
      height:20px;
      // transition: all 100ms ease-in-out;
      // scale(0.2);
      // &:hover {
      //    transform:  scale(1.2) ;
      // }
`;
//
// .contentheaderlink{
//     cursor: pointer;
//     align-self: flex-end;
//     align-content: flex-end;
// }
//
// .contentheaderlink:hover{
//
//     font-variant: inherit;
//     text-decoration: underline;
//
// }
//
// .unit{
//    cursor: pointer;
// }
//
export const Unittext = styled.div`
    font-weight: bold;
    font-size: ${props=>props.winwidth/50}px;
    height:${props=>props.winwidth/22}px;
    display:flex;
    align-items:center;
    justify-content:center;
    color: #08051f;


`;

//
export const UnittextOp = styled.div`

    font-size: ${props=>props.winwidth/50}px;
    color: #b6b7ba;
`;

export const Titletext = styled.div`
    padding-top:8px;
    font-size: ${props=>(props.extrasmall ? props.winwidth/25 : props.winwidth/60)}px;
    color: #0a123c;
    text-align:center;
     /* background: #cbd9e6; */
    width:100%;
`;


export const Menubartext = styled.div`
    padding-top:8px;
    font-weight:bold;
    font-size: ${props=>(props.drawparam.extrasmall ? props.drawparam.winwidth/20 : props.drawparam.winwidth/45)}px;
    color: #0a123c;
    text-align:right;
    padding-right:20px;
     /* background: #cbd9e6; */
    width:100%;
`;
